import { gsap } from 'gsap';
import { isMobile, isTablet, isTabletDown } from './isMobile';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SnapperInstance } from './snapper';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export function HeroScene() {
    var hasVideo = document.getElementById('intro-video');
    var hasMobileVideo = document.getElementById('intro-video-mobile');

    if (hasMobileVideo && hasVideo) {
        hasVideo.style.display = isMobile() ? 'none' : ''
    }


    window.addEventListener('resize', () => {
        if (hasMobileVideo && hasVideo) {
            hasVideo.style.display = isMobile() ? 'none' : ''
        }
    });

    $('.hero__scroll-down-icon').on('click', function () {
        SnapperInstance.snapTo(1);
    })
    var heroContainer = document.querySelector('.hero__clip-container');
    var heroImage = $('.hero__img-block');
    var pos = heroImage.attr('focal-point').split(',');
    var rawWidth = parseInt(heroImage.attr('raw-width'));
    var rawHeight = parseInt(heroImage.attr('raw-height'));
    var width = parseInt(heroImage.attr('current-width'));
    var height = parseInt(heroImage.attr('current-height'));
    var textBlock = document.querySelector('.hero-second-scene__text-block');
    var textAlignment = heroImage.attr('text-align');
    var header = document.querySelector('.header__container');
    var rawRatio = rawWidth / rawHeight;
    var ratio = width / height;
    if (heroImage.width() / heroImage.height() < ratio) {
        heroImage.width(heroImage.height() * ratio);
    }
    if (width > rawWidth && rawRatio < ratio) {
        rawHeight = width / rawWidth * rawHeight;
        rawWidth = width;
    }
    else if (height > rawHeight) {
        rawWidth = height / rawHeight * rawWidth;
        rawHeight = height;
    }
    var oldFocalPoint = pos.length < 3 ? {
        x: parseFloat(pos[1]),
        y: parseFloat(pos[0])
    } : {
        x: (parseFloat(pos[0]) + parseFloat(pos[2])) / 2,
        y: (parseFloat(pos[1]) + parseFloat(pos[2])) / 2
    };
    if (pos.length > 2) {
        var scale = 1 / (parseFloat(pos[3]) - parseFloat(pos[0]));
        rawWidth *= scale;
        rawHeight *= scale;
    }
    var centerX = width / 2;
    var centerY = height / 2;
    var oldX = oldFocalPoint.x * rawWidth;
    var oldY = oldFocalPoint.y * rawHeight;
    var targetRadius = window.innerWidth * .144;
    var endPoint = {
        x: window.innerWidth * .27916,
        y: window.innerHeight * .5 + header.clientHeight / 2
    }
    if (isTablet()) {
        targetRadius = 150;
        endPoint = {
            x: window.innerWidth * .5,
            y: heroContainer.clientHeight * .5
        }
    }
    else if (isMobile()) {
        targetRadius = 94;
        endPoint = {
            x: window.innerWidth * .5,
            y: heroContainer.clientHeight * .5
        }
    }

    targetRadius * 3.333333;
    var upScale = (rawWidth / width);
    var scaledCenterX = centerX * upScale;
    var scaledCenterY = centerY * upScale;
    var newStartX = oldX - scaledCenterX;
    var newEndX = oldX + scaledCenterX;
    if (newStartX < 0) {
        newEndX -= newStartX;
        newStartX = 0;
    }
    else if (newEndX > rawWidth) {
        newStartX -= (newEndX - rawWidth);
        newEndX = rawWidth;
    }

    var newStartY = oldY - scaledCenterY;
    var newEndY = oldY + scaledCenterY;
    if (newStartY < 0) {
        newEndY -= newStartY;
        newStartY = 0;
    }
    else if (newEndY > rawHeight) {
        newStartY -= (newEndY - rawHeight);
        newEndY = rawHeight;
    }

    var newFocalPoint = {
        x: (oldX - newStartX) / (width * upScale),
        y: (oldY - newStartY) / (height * upScale)
    };

    var imageWidth = heroImage.width();
    var imageHeight = heroImage.height();
    var shrunkWidth = imageWidth * .4;
    var shrunkHeight = imageHeight * .4;
    var shift = (heroContainer.clientWidth - heroImage.width()) / 2;
    if (isMobile()) {
        shift = textAlignment === 'right' ? -(shrunkWidth * newFocalPoint.x) : heroContainer.clientWidth - heroImage.width();
    }

    var boundaries = {
        top: shrunkHeight * newFocalPoint.y,
        right: (imageWidth * .6) + shrunkWidth * newFocalPoint.x,
        bottom: (imageHeight * .6) + shrunkHeight * newFocalPoint.y,
        left: shrunkWidth * newFocalPoint.x
    };
    var targetBoundaries = {
        top: endPoint.y - targetRadius,
        right: endPoint.x + targetRadius,
        bottom: endPoint.y + targetRadius,
        left: endPoint.x - targetRadius
    }
    var ratio = Math.max(width / imageWidth, height / imageHeight);
    var xPos = newFocalPoint.x * 100;
    var yPos = newFocalPoint.y * 100;
    gsap.set(heroImage, {
        transformOrigin: xPos + '% ' + yPos + '%',
        x: shift
    });
    var offset = {
        x: endPoint.x - newFocalPoint.x * heroImage.width(),
        y: endPoint.y - newFocalPoint.y * heroImage.height()
    }
    if (offset.y > targetBoundaries.top - boundaries.top) {
        offset.y = targetBoundaries.top - boundaries.top;
    }
    if (offset.y < targetBoundaries.bottom - boundaries.bottom) {
        offset.y = targetBoundaries.bottom - boundaries.bottom;
    }
    if (offset.x > targetBoundaries.left - boundaries.left) {
        offset.x = targetBoundaries.left - boundaries.left;
    }
    if (offset.x < targetBoundaries.right - boundaries.right) {
        offset.x = targetBoundaries.right - boundaries.right;
    }

    if (!hasVideo || !hasMobileVideo) {
        gsap.to(heroImage, 1, {
            x: offset.x,
            y: offset.y,
            scale: .6,
            scrollTrigger: {
                trigger: '.hero',
                start: 'bottom 50%',
                end: '100%',
                scrub: 1
            },
        });
    }
    else {
        gsap.set(heroImage, {
            x: offset.x,
            y: offset.y,
            scale: .6
        });
    }


    //ScrollTrigger.create({
    //    trigger: '.hero',
    //    start: 'top top',
    //    end: '300%',
    //    pin: '.hero__clip-container',
    //    pinSpacing: false,
    //    scrub: 1,
    //});

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.hero',
            start: 'top top',
            end: '100%',
            scrub: 1,
        }
    })

    if (document.querySelector(".header__banner") != null) {
        if (document.body.clientWidth < 768) {
            tl.to('.header__banner', 1, { maxHeight: 0 }).fromTo("#navigator", 1, { height: window.innerHeight - (document.querySelector(".header__banner").clientHeight + document.querySelector(".header__container").clientHeight) + "px" }, { height: window.innerHeight - document.querySelector(".header__container").clientHeight + "px" }, '-=1');
        }
        else {
            tl.to('.header__banner', 1, { maxHeight: 0 })
        }
    }
    if (!isTabletDown()) {
        tl.to('.header__container .grid-container', 1, { height: '7rem' }, '-=1');
        tl.to('.header__logo', 1, { marginTop: '-=1.125rem' }, '-=1');
        if (hasVideo || hasMobileVideo) {
            tl.set('.hero__clip-container', { clipPath: 'circle(14.4vw at 27.916vw ' + endPoint.y + 'px)' }, ' -= 1');
        }
        else {
            tl.to('.hero__clip-container', 5, { clipPath: 'circle(14.4vw at 27.916vw ' + endPoint.y + 'px)' }, '-=1');
        }
    } else if (isTablet()) {
        if (hasVideo || hasMobileVideo) {
            tl
                .set('.hero__clip-container', { clipPath: 'circle(150px at 50% 50%)', y: 16 + textBlock.clientHeight }, '-=1');
        }
        else {
            tl
                .to('.hero__clip-container', 5, { clipPath: 'circle(150px at 50% 50%)', y: 16 + textBlock.clientHeight }, '-=1')
        }
    }
    else {
        if (hasVideo || hasMobileVideo) {
            tl.set('.hero__clip-container', { clipPath: 'circle(94px at 50% 50%)', y: 16 + textBlock.clientHeight }, '-=1');
        } else {
            tl.to('.hero__clip-container', 5, { clipPath: 'circle(94px at 50% 50%)', y: 16 + textBlock.clientHeight }, '-=1');
        }
    }
    if (!hasVideo || !hasMobileVideo) {
        tl.to('.hero__text-block', 5, { y: () => '-=145vh' }, '-=4.5');
    }
    else {
        if (hasVideo.style.display != 'none') {
            tl.to('#intro-video', 3, { autoAlpha: 0, zIndex: 1 });
        }

        if (hasMobileVideo.style.display != 'none') {
            tl.to('#intro-video-mobile', 3, { autoAlpha: 0, zIndex: 1 });
        }
    }
    tl.to('.hero__scroll-down-icon', 1, { opacity: 0 });
    if (hasVideo || hasMobileVideo) {
        tl.to('.hero__clip-container', 1, { autoAlpha: 1 });
    }
    tl.to('.hero-second-scene__text-block h2', 1, { opacity: 1 }, hasVideo || hasMobileVideo ? '-=.5' : '+=2.5');
    tl.to('.hero-second-scene__text-block p', 1, { opacity: 1 }, '-=0.9');
}